import { FC } from 'react';

import { AppRoutes } from 'constants/routes-paths.constants';
import { CustomerRequestSource } from 'interfaces/customer-request-sources.interfaces';
import { ColumnDefaultControls } from 'shared-components/table/ColumnDefaultControls';
import { TableData } from 'shared-components/table/TableData';
import { TableRow } from 'shared-components/table/TableRow';
import { getCommonRoutes } from 'utils/routes.utils';

interface Props {
  handleDelete: VoidFunction;
  data: CustomerRequestSource;
}

export const CustomerRequestSourceTableRow: FC<Props> = ({ handleDelete, data: { id, name } }) => {
  const { editRoute, viewRoute } = getCommonRoutes(AppRoutes.customerRequestSources, id);

  return (
    <TableRow>
      <TableData>
        <ColumnDefaultControls
          handleDelete={handleDelete}
          editRoute={editRoute}
          viewRoute={viewRoute}
          editPermission='customerRequestSources.update'
          deletePermission='customerRequestSources.delete'
          viewPermission='customerRequestSources.view'
        />
      </TableData>
      <TableData>{id}</TableData>
      <TableData className='last:text-left'>{name}</TableData>
    </TableRow>
  );
};
